import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogActions, DialogContent, useTheme } from '@mui/material';
import { MarketButton, MarketHeader } from '@market/react';
import { useOrderDetails } from 'components/context/order_details';
import {
  onCheckoutPageClick,
  CHECKOUT_PAGE_CLICK_EVENTS,
} from 'components/pages/checkout/utilities';

const Pending = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { trackingData } = useOrderDetails();

  const { onClose } = props;

  return (
    <>
      <MarketHeader style={{ margin: theme.spacing(4, 4, 0) }}>
        <h1>{t('checkout.financeApp.modals.pending.title')}</h1>
      </MarketHeader>
      <DialogContent sx={{ px: 4, py: 2 }}>
        <p>{t('checkout.financeApp.modals.pending.body')}</p>
      </DialogContent>
      <DialogActions sx={{ px: 4, pb: 4 }}>
        <MarketButton
          id="continue-btn"
          rank="primary"
          onClick={() => {
            onClose();
            onCheckoutPageClick({
              eventDesc: CHECKOUT_PAGE_CLICK_EVENTS.financing_retry,
              trackingData,
              componentName: 'Financing Application',
              actionItem: 'continue_to_financing_form',
            });
          }}
          style={{ width: '100%' }}
        >
          {t('common.continue')}
        </MarketButton>
      </DialogActions>
    </>
  );
};

export default Pending;
